import React, { useEffect, useState, useContext } from 'react'
import { NameTable } from 'components/NameTable'
import './styles.scss'
import LocalesContext from 'components/_locales/localeContext'

interface Props {
  data: womenMenDataElement[][]
  locales: { title: string; sub: string; label: string }
}

export const Top10 = ({ data, locales }: Props) => {
  const [drawData, setDrawData] = useState<
    [womenMenDataElement[], womenMenDataElement[]]
  >([[], []])
  const [inputData, setInputData] = useState<
    [womenMenDataElement[], womenMenDataElement[]]
  >([[], []])
  const [search, setSearch] = useState<string>('')
  const [showAll, setShowAll] = useState<boolean>(false)

  const __l: localesInterface = useContext<localesInterface>(LocalesContext)

  useEffect(() => {
    setInputData(data)
  }, [])

  useEffect(() => {
    let female = inputData[0].filter(f =>
      f[0].toLocaleLowerCase().startsWith(search.toLocaleLowerCase())
    )
    let male = inputData[1].filter(f =>
      f[0].toLocaleLowerCase().startsWith(search.toLocaleLowerCase())
    )
    if (window.innerWidth < 600) {
      female = female.slice(0, 10)
      male = male.slice(0, 10)
    }

    setDrawData([male, female])
  }, [search, inputData])
  return (
    <div className='Top10'>
      <div className='ui vertical segment '>
        <div className='ui text container'>
          <div className='title'>{locales.title}</div>
          <div className='sub'>{locales.sub}</div>
          <div className='inputwrapper'>
            <input
              type='search'
              onChange={e => {
                setSearch(e.target.value)
              }}
              value={search}
            />
            <div className='smallabel'>{locales.label}</div>
          </div>
        </div>
        <div>
          <NameTable
            data={[
              drawData[0].slice(0, showAll ? 10000 : 10),
              drawData[1].slice(0, showAll ? 10000 : 10)
            ]}
          />
          {(drawData[0].length > 10 || drawData[1].length > 10) && (
            <div className='showall'>
              <button
                onClick={() => {
                  setShowAll(!showAll)
                }}
              >
                {showAll ? 'Nur Top 10 anzeigen' : 'Alle anzeigen'}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
